import { Button, IconButton, Stack } from '@mui/material';
import { SearchField } from '../../../components/fields';
import { TableView } from '../../../components/table-view';
import { filesColumns } from '../_mockdata';
import { IconPen, IconTrash } from '../../../components/icons';
import { useDialog } from '../../../core/hooks/useDialog';
import { ConfirmDialog } from '../../../components/dialogs/ConfirmDialog';
import { useParams } from 'react-router';
import { useSnackbar } from '../../../core/hooks/useSnackbar';
import { useListResource } from '../../../core/hooks/useListResource';
import { FileApi } from '../../../core/http';
import { get } from 'lodash';
import { UploadNewFileDialog } from '../dialogs/UploadNewFileDialog';
import { PermissionView } from '../../../components/permission-view';

const fileApi = new FileApi();

export const Files = () => {
  const { id } = useParams();
  const [openUploadDialog] = useDialog(UploadNewFileDialog);
  const [openConfirmDialog, closeConfirm] = useDialog(ConfirmDialog);
  const { showMessage } = useSnackbar();

  const {
    data: filesResponse,
    isLoading,
    fetchData,
    deleteRecord,
    handleChangeParams,
    handleChangeSort,
    pagination
  } = useListResource(fileApi, {
    defaultParams: {
      rootType: 'employee',
      rootGuid: id,
      rootId: id
    }
  });

  const handleDelete = (uuid: string) => () => {
    openConfirmDialog({
      title: 'Delete file',
      message: 'Do you really want to delete this file?',
      onConfirm: () => {
        deleteRecord(uuid).then(() => {
          showMessage('File is deleted successfully');
          closeConfirm();
          fetchData();
        });
      }
    });
  };

  const handleCreate = () => () => {
    openUploadDialog({
      employeeUuid: id,
      onSuccess: () => {
        showMessage('File was created successfully');
        closeConfirm();
        fetchData();
      },
      onError: () => {
        closeConfirm();
        showMessage('Something went wrong, please try again later.');
      }
    });
  };

  const handleEdit = (uuid: string) => () => {
    openUploadDialog({
      uuid,
      fetchData,
      onSuccess: () => {
        showMessage('File was updated successfully');
        closeConfirm();
        fetchData();
      },
      onError: () => {
        closeConfirm();
        showMessage('Something went wrong, please try again later.');
      }
    });
  };
  const filesData = get(filesResponse, 'items', []);

  return (
    <>
      <Stack direction="row" justifyContent="space-between" mb={3}>
        <PermissionView permission="modifyUploadNewFiles">
          <Button onClick={handleCreate()}>Upload new file</Button>
        </PermissionView>
        <SearchField
          sx={{ width: 400 }}
          size="small"
          placeholder="Search"
          onChange={(value) => handleChangeParams('search', value)}
        />
      </Stack>
      <TableView
        pagination={pagination}
        onChangeSort={handleChangeSort}
        loading={isLoading}
        showEmptyState
        EmptyStateProps={{
          description: 'null'
        }}
        columns={[
          ...filesColumns,
          {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            cellProps: {
              width: 50
            },
            render: (_, record) => (
              <Stack direction="row" alignItems="center">
                <PermissionView permission="modifyUploadNewFiles">
                  <IconButton size="small" onClick={handleEdit(record.uuid)}>
                    <IconPen />
                  </IconButton>
                </PermissionView>
                <PermissionView permission="modifyUploadNewFiles">
                  <IconButton size="small" onClick={handleDelete(record.uuid)}>
                    <IconTrash />
                  </IconButton>
                </PermissionView>
              </Stack>
            )
          }
        ]}
        dataSource={filesData}
      />
    </>
  );
};
